// 🔴 OMV-12 — rendu lisible des specs techniques extraites des fiches France Air.
// Source UNIQUE (importée par CataloguePage + son banc) : ⛔ pas de duplication.
// Clé inconnue ⇒ humanisée (underscores → espaces). ⛔ Aucune valeur inventée : on
// AFFICHE ce que l'extraction a mis dans `caracteristiques` (specs FIABLES).
export const CARACT_LABELS = {
  resistance_thermique_r: "Résistance R", debit_air_m3h: "Débit d'air",
  debit_max_m3h: "Débit max", debit_mini_m3h: "Débit mini",
  puissance_w: "Puissance", puissance_absorbee_w: "Puissance absorbée",
  pression_pa: "Pression", niveau_sonore_db: "Niveau sonore",
  lwa_db: "Puissance acoustique (LwA)", lpa_3m_db: "Pression acoustique (LpA à 3 m)",
  classe_energie: "Classe énergie", tension_v: "Tension", intensite_a: "Intensité",
  nombre_piquages: "Nb piquages", diametre_mm: "Diamètre", poids_kg: "Poids",
  rendement_pct: "Rendement", type_moteur: "Moteur",
};
export const CARACT_UNITES = {
  resistance_thermique_r: " m²·K/W", debit_air_m3h: " m³/h", debit_max_m3h: " m³/h",
  debit_mini_m3h: " m³/h", puissance_w: " W", puissance_absorbee_w: " W",
  pression_pa: " Pa", niveau_sonore_db: " dB", lwa_db: " dB(A)", lpa_3m_db: " dB(A)", tension_v: " V",
  intensite_a: " A", diametre_mm: " mm", poids_kg: " kg", rendement_pct: " %",
};
export const humaniseCle = (k) =>
  (CARACT_LABELS[k] || String(k).replace(/_/g, " ").replace(/\b\w/, (c) => c.toUpperCase()));

/** dict specs → [{label, texte}] prêt à afficher. ⛔ ignore les valeurs vides. */
export function caracteristiquesListe(carac) {
  if (!carac || typeof carac !== "object") return [];
  return Object.entries(carac)
    .filter(([, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => ({ label: humaniseCle(k), texte: `${v}${CARACT_UNITES[k] || ""}` }));
}

// 🔴 N°980 — ÉDITION des caractéristiques depuis la fiche produit (CataloguePage).
// Même source unique que l'affichage : les libellés connus (CARACT_LABELS) sont
// proposés, et un libellé saisi tel qu'affiché retrouve SA clé canonique.
const sansAccents = (t) => String(t).normalize("NFD").replace(/[̀-ͯ]/g, "");

/** Libellé ou clé saisi(e) → clé canonique (`Débit d'air` → `debit_air_m3h`). */
export function cleCaracteristique(saisie) {
  const brut = String(saisie || "").trim();
  if (!brut) return "";
  if (CARACT_LABELS[brut]) return brut;
  const parLibelle = Object.entries(CARACT_LABELS)
    .find(([, lib]) => lib.toLowerCase() === brut.toLowerCase());
  if (parLibelle) return parLibelle[0];
  return sansAccents(brut).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}

/** Valeur saisie → nombre si c'est un nombre FR/EN pur (« 1 250,5 »), sinon texte. */
export function valeurCaracteristique(saisie) {
  const t = String(saisie ?? "").trim();
  if (!t) return "";
  const n = t.replace(/[\s ]/g, "").replace(",", ".");
  return /^-?\d+(\.\d+)?$/.test(n) ? Number(n) : t;
}

/** dict stocké → lignes éditables [{cle, valeur}] (ordre conservé). */
export function caracteristiquesVersLignes(carac) {
  if (!carac || typeof carac !== "object") return [];
  return Object.entries(carac).map(([cle, valeur]) => ({
    cle, valeur: valeur === null || valeur === undefined ? "" : String(valeur),
  }));
}

/**
 * lignes éditables → { caracteristiques, erreurs }.
 * Ligne entièrement vide ⇒ ignorée. Clé sans valeur, valeur sans clé ou clé
 * en double ⇒ ERREUR nommée (⛔ aucune donnée écartée en silence).
 * Aucune ligne ⇒ caracteristiques = null (le champ est vidé).
 */
export function lignesVersCaracteristiques(lignes) {
  const out = {};
  const erreurs = [];
  (lignes || []).forEach((l, i) => {
    const cle = cleCaracteristique(l?.cle);
    const valeur = valeurCaracteristique(l?.valeur);
    if (!cle && valeur === "") return;
    if (!cle) { erreurs.push(`ligne ${i + 1} : caractéristique sans nom`); return; }
    if (valeur === "") { erreurs.push(`${humaniseCle(cle)} : valeur manquante`); return; }
    if (Object.prototype.hasOwnProperty.call(out, cle)) {
      erreurs.push(`${humaniseCle(cle)} : saisie en double`); return;
    }
    out[cle] = valeur;
  });
  return { caracteristiques: Object.keys(out).length ? out : null, erreurs };
}
